import _     from "lodash";
import axios from 'axios';
import React, {Component} from 'react';
import {Divider, Label, Placeholder, Header} from 'semantic-ui-react';
import {Segment,Item, TextArea, Image, Message, Modal,Dimmer, Loader, Form, Icon, Table, Popup, Button, Card} from 'semantic-ui-react';

const open = function(url){
  window.location.href = url;
}

const resources = [];

class Messages extends Component {
    constructor() {
        super(...arguments);
    }

    state = {
      list:[],
    }

    async load() {
      const {data} = await axios.get("/site/messages");
      const list   = data.data.filter((i)=>{return i.type == "message"}).map((item)=>{
        const {title,desc} = JSON.parse(item.content)
        return {id:item.id,title,desc};
      })
      this.setState({ list })
    }

    componentDidMount() {
        this.load()
    }

    render() {
      return (<React.Fragment>
        <Header
          as='h2'
          content='活动公告'
          subheader="正在进行的活动"
        />

      {this.state.list.map((item,index)=>{
        return (<div>
          <Header as='h4' dividing color="green">
            {item.title}
          </Header>
          <Segment attached>
            {item.desc}
          </Segment>
    </div> )
      } )}
    </React.Fragment>)

    }
}

export default Messages;
